import Macy from 'macy'

document.addEventListener('app:load', init)

function init ()
{
	if (!document.body.classList.contains('page-template-temoignages'))
	{
		return
	}
	
	if (!document.querySelector('section .temoignages'))
	{
		return
	}
	
	Macy({
		container: 'section .temoignages',
		trueOrder: true,
		waitForImages: false,
		margin: 30,
		columns: 3,
		breakAt: {
			1160: 2,
			750: 1
		}
	})
	
	document.querySelectorAll('section .temoignages .item a').forEach(_ =>
	{
		_.addEventListener('click', (e) =>
		{
			e.preventDefault()
			
			const popup = document.querySelector('#popup-testimonial')
			const text = _.parentElement.querySelector('.text-full').innerHTML
			const author = _.parentElement.querySelector('.author').innerHTML
			
			popup.querySelector('.text').innerHTML = text
			popup.querySelector('.author').innerHTML = author
			popup.classList.add('visible')
			
			popup.querySelector('.close').addEventListener('click', () =>
			{
				popup.classList.remove('visible')
			})
		})
	})
}
